import utils from 'components/utilsComponent';

/**
 * Подгружаем скрипт JS API Яндекс.Карт версии 2.1
 */
utils.loadScript('https://api-maps.yandex.ru/2.1.73/?lang=ru_RU').then(() => {
    ymaps.ready(function() {
        // вызываем метод инициализации всех блоков типа "Яндекс.Карта"
        document.querySelectorAll('.yandex_map').forEach($element => {
            const yandexBlock = new YandexBlock();

            yandexBlock.init($element);
        });
    });
});

function YandexBlock() {
    /**
     * Инициализация блока
     */
    this.init = function(block) {
        const latitude  = block.getAttribute('data-latitude');
        const longitude = block.getAttribute('data-longitude');
        const zoom      = block.getAttribute('data-zoom');
        const name      = block.getAttribute('data-name');
        const description   = block.getAttribute('data-description');

        // получаем метки
        const placemarks = [];
        block.querySelectorAll('.placemark').forEach(function($placemark, i) {
            placemarks.push({
                'latitude':     $placemark.getAttribute('data-latitude'),
                'longitude':    $placemark.getAttribute('data-longitude'),
                'name':         $placemark.getAttribute('data-name'),
                'description':  $placemark.getAttribute('data-description')
            });
        });

        // создаем карту
        block.Map = new ymaps.Map(block, {
            center: [latitude, longitude],
            zoom:   zoom
        });

        // добавляем метки
        if (placemarks && placemarks.length) {
            for(let i = 0, k = placemarks.length; i < k; i++) {
                const item = placemarks[i];

                block.Map.geoObjects.add(new ymaps.Placemark([item.latitude, item.longitude], {
                    balloonContentBody:
                        (item.name ? '<ymaps class="ymaps-2-1-27-islets_card__title">'+item.name+'</ymaps>' : '')
                }, {
                    iconLayout:         'default#image',
                    iconImageHref:      '/app/src/img/new/logo_optimized.svg',
                    iconImageSize:      [50, 50],
                    iconImageOffset:    [-25, -50]
                }));
            }
        }
    }
}